import { Twitter, Linkedin, Instagram } from "lucide-react";


const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-green-700 to-emerald-800 text-white p-6 mt-10">
      <div className="p-2 container mx-auto flex flex-col items-center">

        {/* Navigation Links */}
        <div className="mb-6 flex flex-wrap justify-center gap-4">
          <a href="/" className="hover:underline">Home</a>
          <a href="/about" className="hover:underline">About</a>
          <a href="/membership" className="hover:underline">Membership</a>
          <a href="/programs" className="hover:underline">Programs</a>
          <a href="/mentee" className="hover:underline">Our Mentees</a>
          <a href="/contact" className="hover:underline">Contact</a>
        </div>

        {/* Social Media Links */}
        <div className="flex space-x-6 mb-6">
          <a 
            href="https://twitter.com" 
            className="hover:text-yellow-500 transition-colors"
            aria-label="Twitter"
          >
            <Twitter size={24} />
          </a>
          <a 
            href="https://linkedin.com" 
            className="hover:text-yellow-500 transition-colors"
            aria-label="LinkedIn"
          >
            <Linkedin size={24} />
          </a>
          <a 
            href="https://instagram.com" 
            className="hover:text-yellow-500 transition-colors"
            aria-label="Instagram"
          >
            <Instagram size={24} />
          </a>
        </div>

        {/* Copyright */}
        <p className="text-sm text-center">
          &copy; {new Date().getFullYear()} Led2Lead Consulting Limited. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;